import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, extractBadgeInfo, getHandle } from "../helpers"

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)

    const firstDashIndex = product.name.indexOf(" - ");
    const brand = product.name.substring(0, firstDashIndex);
    const rest = product.name.substring(firstDashIndex + 3); // Skip the " - "

    const badgeTitle = extractBadgeInfo(product.tags1)?.label ?? "";
    const badgeColor = extractBadgeInfo(product.tags1)?.color ?? "";

    return (
        <SerpElement
            as="li"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            data-grid-item
            class="results-grid__tile nosto_card"
        >
            <nosto-dynamic-card handle={getHandle(product.url)} template="card-nosto">
                <div class="product-card-skeleton"></div>
            </nosto-dynamic-card>
            {/* <product-card class="product-card  " data-product-card="" data-product-card-id="7434988519601">
                <div class="product-card__image">
                    <a href={product.url}>
                        <div class="component-image__wrapper aspect-ratio aspect-ratio--square ">
                        <img class="component-image__image" src={`${product.imageUrl}?width=640`} loading="lazy" width="1080" height="1080" alt={product.name} style="--_focal-point: 50.0% 50.0%;" />
                        </div>
                    </a>
                </div>
                <div class="product-card__meta">
                    <div class="product__reviews">
                        <span class="product__reviews-rating">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3L14.645 8.35942L20.5595 9.21885L16.2798 13.3906L17.2901 19.2812L12 16.5L6.70993 19.2812L7.72025 13.3906L3.44049 9.21885L9.35497 8.35942L12 3Z" stroke="#2F2724" stroke-linecap="round"></path>
                        </svg>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3L14.645 8.35942L20.5595 9.21885L16.2798 13.3906L17.2901 19.2812L12 16.5L6.70993 19.2812L7.72025 13.3906L3.44049 9.21885L9.35497 8.35942L12 3Z" stroke="#2F2724" stroke-linecap="round"></path>
                        </svg>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3L14.645 8.35942L20.5595 9.21885L16.2798 13.3906L17.2901 19.2812L12 16.5L6.70993 19.2812L7.72025 13.3906L3.44049 9.21885L9.35497 8.35942L12 3Z" stroke="#2F2724" stroke-linecap="round"></path>
                        </svg>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 3L14.645 8.35942L20.5595 9.21885L16.2798 13.3906L17.2901 19.2812L12 16.5L6.70993 19.2812L7.72025 13.3906L3.44049 9.21885L9.35497 8.35942L12 3Z" stroke="#2F2724" stroke-linecap="round"></path>
                        </svg>
                        <span class="partial-star">
                            <span style="position: absolute; overflow: hidden; width: 80.0%;">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 3L14.645 8.35942L20.5595 9.21885L16.2798 13.3906L17.2901 19.2812L12 16.5L6.70993 19.2812L7.72025 13.3906L3.44049 9.21885L9.35497 8.35942L12 3Z" stroke="#2F2724" stroke-linecap="round"></path>
                                </svg>
                            </span>
                            <span style="opacity: 0.2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 3L14.645 8.35942L20.5595 9.21885L16.2798 13.3906L17.2901 19.2812L12 16.5L6.70993 19.2812L7.72025 13.3906L3.44049 9.21885L9.35497 8.35942L12 3Z" stroke="#2F2724" stroke-linecap="round"></path>
                                </svg>
                            </span>
                        </span>
                        </span>
                        <span class="product__reviews-count">(5)</span>
                    </div> 
                    <p class="product-card__vendor">${brand}</p>
                    <h4 class="product-card__title">
                        <a href={product.url}>
                        {rest}
                        </a>
                    </h4>
                    <div class="product-card__price">
                        <a href={product.url}>
                        <span>
                        {format(product.price)}
                        </span>
                        </a>
                    </div>
                    <product-quick-add class="product-card__quick-add" data-product-card-id={product.productId}>
                        <svg width="48" height="48" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="40" height="40" rx="20" fill="#2F2724"></rect>
                        <path d="M20 13V27M13 20H27" stroke="#95F10C" stroke-width="1.5" stroke-linejoin="round"></path>
                        </svg>
                    </product-quick-add>
                    <form method="post" action="/cart/add" accept-charset="UTF-8" class="product-card__form" enctype="multipart/form-data" data-product-card-form={product.productId}>
                        <input type="hidden" name="form_type" value="product" /><input type="hidden" name="utf8" value="✓" />
                        <product-quick-add data-product-card-id={product.productId} class="product-card__quick-add product-card__quick-add--close">
                        <svg width="48" height="48" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="20" fill="#2F2724"></rect>
                            <path d="M20 13V27M13 20H27" stroke="#95F10C" stroke-width="1.5" stroke-linejoin="round"></path>
                        </svg>
                        </product-quick-add>
                        <fieldset class="product-card__variants">
                        <legend class="visually-hidden">Please select an option</legend>
                        {product.skus.map((sku, index) => {
                            return (<>
                            <input name="id" id={`variant_${sku.id}_template--serp-nosto__main`} value={sku.id} type="checkbox" class="visually-hidden" />
                            <label for={`variant_${sku.id}_template--serp-nosto__main`}>
                            <span class="product-card__variant-title">
                                {sku.name}
                            </span>
                            <span class="product-card__variant-price">
                            <span data-card-price="549">
                            {format(sku.price)}
                            </span>
                            </span>
                            </label>
                            </>)
                        })}
                        </fieldset>
                        <div class="product-card__actions">
                        <div class="product-card__quantity">
                            <button type="button" class="quantity-button" data-quantity-decrease="">
                                <svg aria-label="Minus icon" class="icon icon--minus" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" vector-effect="non-scaling-stroke" d="M6 12h12"></path>
                                </svg>
                            </button>
                            <input type="number" name="quantity" value="1" min="1" aria-label="Quantity" class="quantity-input" data-quantity-input="" />
                            <button type="button" class="quantity-button" data-quantity-increase="">
                                <svg aria-label="Plus icon" class="icon icon--plus" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" vector-effect="non-scaling-stroke" d="M12 6v12M6 12h12"></path>
                                </svg>
                            </button>
                        </div>
                        <div class="product-card__select-options" data-select-options="" style="display: flex;">
                            <span>
                            Select Options
                            </span>
                            <span class="product-card__select-options-icon">
                                <svg aria-label="Chevron up icon" class="icon icon--chevron-up" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M18 16l-6-6-6 6"></path>
                                </svg>
                            </span>
                        </div>
                        <button type="submit" class="btn btn--small product-card__add" data-add-to-cart="" style="display: none;" aria-label="Huma Gel - Original - Mangoes - Add to Bag">
                            <span data-add-to-cart-text="">Add to Bag</span>
                            <span data-add-to-cart-price="">$0.00</span>
                            <span data-added-tick="">
                                <svg aria-label="Tick icon" class="icon icon--tick" width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13 1l-8.25 9L1 5.91" stroke="currentColor"></path>
                                </svg>
                            </span>
                        </button>
                        </div>
                        <input type="hidden" name="product-id" value={product.productId} />
                    </form>
                </div>
                <rivo-favorite-button class="status__favorite-button wishlist-toggle" data-product-id={product.productId} rivo-ax-data="" rivo-ax-html="$store.icons.heart" rivo-ax-show="$store.rivo_aw_settings?.favorites_enabled &amp;&amp; (!$store.rivo_profile_customer || $store.loading_states.global_favorite_buttons)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                        <path d="M 15 7 C 8.9424416 7 4 11.942442 4 18 C 4 22.096154 7.0876448 25.952899 10.851562 29.908203 C 14.615481 33.863507 19.248379 37.869472 22.939453 41.560547 A 1.50015 1.50015 0 0 0 25.060547 41.560547 C 28.751621 37.869472 33.384518 33.863507 37.148438 29.908203 C 40.912356 25.952899 44 22.096154 44 18 C 44 11.942442 39.057558 7 33 7 C 29.523564 7 26.496821 8.8664883 24 12.037109 C 21.503179 8.8664883 18.476436 7 15 7 z"></path>
                    </svg>
                </rivo-favorite-button>
                {badgeTitle != "" && <div class="product-badges product-card__badges" data-product-badges="">
                    <div class="badge" style={`background-color: ${badgeColor};`}>
                        {badgeTitle}
                    </div>
                </div>}
                <div class="product-badges product-card__badges" data-product-badges="">
                </div>
            </product-card> */}
        </SerpElement>
    )
}
